/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AddCourseModuleRequestSegmentId } from './addCourseModuleRequestSegmentId';

/**
 * request to add a module to a course
 */
export interface AddCourseModuleRequest {
  segmentId?: AddCourseModuleRequestSegmentId;
}
